import { render, staticRenderFns } from "./Tukang_Staff.vue?vue&type=template&id=d60baea2&scoped=true&"
import script from "./Tukang_Staff.vue?vue&type=script&lang=js&"
export * from "./Tukang_Staff.vue?vue&type=script&lang=js&"
import style0 from "./Tukang_Staff.vue?vue&type=style&index=0&id=d60baea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60baea2",
  null
  
)

export default component.exports